import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    offer: {},
    selecting: false,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.OFFER_SELECTING_FAILURE:
        return Object.assign({}, state, {
            error: action.error,
            hasError: true,
            selecting: false,
        });

    case types.OFFER_SELECTING_PENDING:
        return Object.assign({}, state, {
            error: null,
            hasError: false,
            selecting: true,
        });

    case types.OFFER_SELECTING_SUCCESS:
        return Object.assign({}, state, {
            error: null,
            hasError: false,
            offer: action.res.data.offer,
            // Kept true so the spinner covers the gap until navigation completes. The store
            // outlives the offers page, so OffersPageComponent clears it with OFFER_SELECTING_RESET
            // when the page is shown again (browser Back).
            selecting: true,
        });

    case types.OFFER_SELECTING_RESET:
        // offer is kept: the registration pages read the selected offer after navigating away
        return Object.assign({}, state, {
            error: null,
            hasError: false,
            selecting: false,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
